import type { ApiClient } from "@/lib/api";

export type UpdateSessionVerificationRequest = {
  unsafe_skip_verification: boolean;
  verifier_url: string | null;
};

export const updateSessionVerification = async (options: {
  client: ApiClient;
  settings: UpdateSessionVerificationRequest;
}): Promise<void> => {
  const { client, settings } = options;
  await client.put("/settings/session_verification", settings);
};
